module.exports = __webpack_public_path__ + "assets/img/bulb.021e2d9a.svg";